import request from 'src/utils/request';

//发放数据列表
export const getReleaseDataList = (params) =>
  request.get('/api/car/admin/dataSearch/releaseData/list', { params });

//发放数据详情
export const getreleaseDataDetail = (id) =>
  request.get(`/api/car/admin/dataSearch/releaseData/details/${id}`);

//导出发放数据
export const exportReleaseData = (params) =>
  request.post('/api/car/admin/dataSearch/releaseData/export', params, { responseType: 'blob' });

//订单数据-列表
export const getOrderDataList = (params) =>
  request.get('/api/car/admin/dataSearch/orderData/list', { params });

//订单数据-导出
export const exportOrderData = (params) =>
  request.post('/api/car/admin/dataSearch/orderData/export', params, { responseType: 'blob' });

//权益状态
export const getRightStatus = () => request.get('/api/car/admin/common/rightsStatus');

//发放状态
export const getReleaseStatus = () => request.get('/api/car/admin/common/releaseStatus');

//审核状态
export const getAuditStatus = (params) =>
  request.get('/api/car/admin/common/auditStatus', { params });

//删除待抽奖数据
export const removeGrantDetail = (grantDetailIds) =>
  request.delete('/api/car/admin/dataSearch/deleteReleaseData', {
    data: { grantDetailIds },
  });

/**白名单数据分页列表 */
export const getGrantDetailList = (params) =>
  request.get('/api/car/admin/grantDetail/page', { params });

/**白名单数据导出 */
export const exportGrantDetail = (params, responseType = 'blob') =>
  request.post(' /api/car/admin/grantDetail/export', params, { responseType });

/**白名单数据-详情 */
export const getGrantDetailPage = (id) => request.get(`/api/car/admin/grantDetail/detail/${id}`);

/**白名单数据-详情-字段 */
export const getGrantDetailField = (id) =>
  request.get(`/api/car/admin/grantDetail/detail/field/${id}`);

/**删除发放数据数据 */
export const deleteReleaseData = (grantDetailIds) =>
  request.delete('/api/car/admin/grantDetail/deleteReleaseData', { data: grantDetailIds });

/** 停止发放 */
export const stopReissue = (data) => request.put('/api/car/admin/grantDetail/reissue/stop', data);

/**下发时间修改 */
export const changeReissueTime = (data) =>
  request.post('/api/car/admin/grantDetail/insurance/update', data);

/**作废作废DA名单 */
export const wasteBank = (params) => request.post('/api/car/admin/bank/waste', null, { params });

/** 名单状态推送 */
export const pushDetailStatus = (data) =>
  request.post('/api/car/admin/grantDetail/push/status/detail', data);

/** 订单状态推送 */
export const pushPrizeStatus = (data) =>
  request.post('/api/car/admin/grantDetail/push/status/prize', data);
